export function prettifyDate(stringDate) {
    if(stringDate == null) {
        return "-";
    }
    let date = Date.parse(stringDate);
    return new Intl.DateTimeFormat('el-GR', { dateStyle: 'short'}).format(date);
}

export function prettifyDateTime(stringDate) {
    if(stringDate == null) {
        return "-";
    }
    let date = Date.parse(stringDate);
    return new Intl.DateTimeFormat('el-GR',{ dateStyle: 'short', timeStyle: 'short' }).format(date);
}

export function prettifyDateTimeLong(stringDate) {
    if(stringDate == null) {
        return "-";
    }
    let date = Date.parse(stringDate);

    let options = {
        weekday: "long",
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false,
    };

    return new Intl.DateTimeFormat('el-GR', options).format(date);
}

export function prettifyMoney (amount) {
    if(amount == null) {
        return "-";
    }
    return `${(amount/100).toFixed(2)} €`;
}